/* eslint-disable no-unused-vars */
import Swiper from 'swiper/swiper-bundle';

function initHighlightedContent(section) {
  var dataScript = section.querySelector('.hc-videos-data');
  if (!dataScript) return;

  var videosData = [];
  try {
    videosData = JSON.parse(dataScript.textContent);
  } catch (e) {
    console.error('Error parse video:', e);
    return;
  }

  var mainEmbed = section.querySelector('.hc-main-video__embed');
  var thumbsEl = section.querySelector('.hcSwiper');
  
  if (!mainEmbed || !videosData.length) return;

  var currentIndex = 0;

  // 1. Play video on main play button click
  var playBtn = mainEmbed.querySelector('.hc-play-btn');
  if (playBtn) {
    playBtn.addEventListener('click', function () {
      mainEmbed.innerHTML = videosData[currentIndex];
      mainEmbed.classList.add('is-playing');
      mainEmbed.style.backgroundImage = 'none';
    });
  }

  if (!thumbsEl) return;

  // 2. Init Swiper
  var swiper = new Swiper(thumbsEl, {
    spaceBetween: 16,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    keyboard: { enabled: true },
    navigation: {
      nextEl: section.querySelector('.hc-button-next'),
      prevEl: section.querySelector('.hc-button-prev'),
    },
    breakpoints: {
      320: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
    },
  });

  // 3. Keyboard activation for thumbnail slides
  swiper.slides.forEach(function (slide) {
    slide.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        slide.click();
      }
    });
  });

  // 4.Play video
  swiper.on('click', function () {
    var index = swiper.clickedIndex;
    if (index === undefined || index === null) return;

    currentIndex = index;

    swiper.slides.forEach(function (slide) {
      slide.classList.remove('is-active');
    });
    swiper.slides[index].classList.add('is-active');

    if (videosData[index]) {
      mainEmbed.innerHTML = videosData[index];
      mainEmbed.classList.add('is-playing');
      mainEmbed.style.backgroundImage = 'none';
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pe-highlighted-content').forEach(initHighlightedContent);
});

if (window.acf) {
  window.acf.addAction('render_block_preview/type=highlighted-content', function($el) {
    var block = $el[0];
    initHighlightedContent(block);
  });
}


// WEBPACK FOOTER //
// ./scripts/block-highlighted-content.js